import type { CmChecklist } from '@luxuryescapes/contract-svc-offer';

import type { EgsCapacityRowView, EgsMarginRowView } from '../../tabs/egs/types';
import type { WithChecklistItemMetadata } from '../../types';
import { presentRowBase } from '../rowBase';

export interface PresentedEgs {
  capacity: Array<WithChecklistItemMetadata<EgsCapacityRowView>>;
  margin: Array<WithChecklistItemMetadata<EgsMarginRowView>>;
}

export function presentEgsRows({
  capacityRows,
  marginRows,
}: {
  capacityRows: Array<CmChecklist.EgsCapacityRow>;
  marginRows: Array<CmChecklist.EgsMarginRow>;
}): PresentedEgs {
  return {
    capacity: capacityRows.map((row, index) => ({
      ...presentRowBase(row),
      egsCapacity: row.evidence.egs_capacity ?? undefined,
      field: 'EGS capacity',
      includedCapacity: row.evidence.included_capacity ?? undefined,
      maxRoomCapacity: row.evidence.max_room_capacity ?? undefined,
      name: row.subject.package_name ?? `Package ${index + 1}`,
      roomName: row.subject.room_name || 'Room not mapped',
      roomRateId: row.subject.room_rate_id ?? undefined,
      roomTypeId: row.subject.room_type_id ?? undefined,
    })),
    margin: marginRows.map((row) => ({
      ...presentRowBase(row),
      ageRange: row.subject.age_range ?? undefined,
      beddingType: row.subject.bedding_type ?? undefined,
      collectedBy: row.subject.collected_by ?? undefined,
      costPrice: row.evidence.cost_price ?? undefined,
      currencyCode: row.subject.currency_code,
      extraGuestType: row.subject.extra_guest_type ?? undefined,
      field: 'Extra Guest Surcharges margin',
      inclusions: row.subject.inclusions ?? undefined,
      margin: row.evidence.margin ?? undefined,
      marginBand: row.evidence.margin_band ?? undefined,
      name: row.subject.name ?? row.subject.egs_id,
      opportunityName: row.subject.opportunity_id ?? undefined,
      sellPrice: row.evidence.sell_price ?? undefined,
    })),
  };
}
